import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const PushLine16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3136 3.96593C13.0926 3.96593 13.7242 3.3344 13.7242 2.55535C13.7242 1.77631 13.0926 1.14478 12.3136 1.14478C11.5345 1.14478 10.903 1.77631 10.903 2.55535C10.903 3.3344 11.5345 3.96593 12.3136 3.96593ZM12.3136 5.37649C12.6365 5.37649 12.9386 5.61425 12.9386 5.93717V13.0453C12.9386 14.2189 11.9872 15.1703 10.8136 15.1703H5.3501C4.17649 15.1703 3.2251 14.2189 3.2251 13.0453V3.35004C3.2251 2.17643 4.17649 1.22504 5.3501 1.22504H9.00039C9.37357 1.22504 9.62381 1.62328 9.54929 1.98895C9.4959 2.25091 9.28069 2.47504 9.01334 2.47504H5.3501C4.86685 2.47504 4.4751 2.86679 4.4751 3.35004V10.9518C4.4751 11.2279 4.69896 11.4518 4.9751 11.4518H11.1886C11.4647 11.4518 11.6886 11.2279 11.6886 10.9518V5.93717C11.6886 5.61425 11.9907 5.37649 12.3136 5.37649ZM4.4751 13.0453V13.0453C4.4751 12.8556 4.62888 12.7018 4.81859 12.7018H11.3451C11.5348 12.7018 11.6886 12.8556 11.6886 13.0453V13.0453C11.6886 13.5285 11.2968 13.9203 10.8136 13.9203H5.3501C4.86685 13.9203 4.4751 13.5285 4.4751 13.0453Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
